module.exports = __webpack_public_path__ + "e5035a584c13256d508cd2c2b57e35fe.png";